module.exports = __webpack_public_path__ + "static/media/Tracey Depellegrin Headshot_1696358896014.2fe533e2.jpg";